import { NgModule } from '@angular/core';
import { CommonModule, DatePipe, NgOptimizedImage } from '@angular/common';
import { NavbarComponent } from './navbar/navbar.component';
import { QuestionComponent } from './question/question.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LongLoadingComponent } from './long-loading/long-loading.component';
import { ShortLoadingComponent } from './short-loading/short-loading.component';
import { ToastComponent } from './toast/toast.component';
import { MatTabsModule } from '@angular/material/tabs';
import { CdkDrag, CdkDragHandle, CdkDropList } from '@angular/cdk/drag-drop';
import { PipesModule } from '../pipes/pipes.module';
import { HomeNavbarComponent } from './home-navbar/home-navbar.component';
import { QuestionnaireCardComponent } from './questionnaire/questionnaire-card/questionnaire-card.component';
import { EditQuestionComponent } from './questionnaire/questionnaire-builder/edit-question/edit-question.component';
import { MatRippleModule } from '@angular/material/core';
import { QuestionnaireResponseAnswersComponent } from './questionnaire/questionnaire-response-answers/questionnaire-response-answers.component';
import { MatDialogModule } from '@angular/material/dialog';
import { ChartComponent } from './chart/chart.component';
import { FreetextSummaryComponent } from './freetext-summary/freetext-summary.component';
import { InviteLinkDetailsComponent } from './questionnaire/questionnaire-invites/invite-link-details/invite-link-details.component';
import { AccountDetailsComponent } from '../pages/admin/profile/account-details/account-details.component';
import { BillingDetailsComponent } from '../pages/admin/profile/billing-details/billing-details.component';
import { TransactionHistoryComponent } from '../pages/admin/profile/transaction-history/transaction-history.component';
import { CreateInviteLinkComponent } from './questionnaire/questionnaire-invites/create-invite-link/create-invite-link.component';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { CreateUserComponent } from '../pages/admin/profile/create-user/create-user.component';
import { AccountSelectComponent } from './account/account-select/account-select.component';
import { SwitchModalComponent } from './account/account-select/switch-modal/switch-modal.component';
import { PrivacyPolicyComponent } from './help/privacy-policy/privacy-policy.component';
import { TermsAndConditionsComponent } from './help/terms-and-conditions/terms-and-conditions.component';
import { BetaLabelComponent } from './layout/beta-label/beta-label.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';
import { EditBranchConditionComponent } from './questionnaire/questionnaire-builder/edit-branch-condition/edit-branch-condition.component';
import { PaginatorComponent } from './paginator/paginator.component';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { RespondentQuestionnairesComponent } from './survey-respondents/respondent-questionnaires/respondent-questionnaires.component';
import { RespondentAssociatedQuestionnairesComponent } from './survey-respondents/respondent-associated-questionnaires/respondent-associated-questionnaires.component';
import { RespondentScheduledQuestionnairesComponent } from './survey-respondents/respondent-scheduled-questionnaires/respondent-scheduled-questionnaires.component';
import { RespondentAlreadyExistsModalComponent } from './modals/respondent-already-exists-modal/respondent-already-exists-modal.component';
import { NewScheduledQuestionnaireModalComponent } from './modals/new-scheduled-questionnaire-modal/new-scheduled-questionnaire-modal.component';
import { RespondentDetailsFormComponent } from './survey-respondents/respondent-details-form/respondent-details-form.component';
import { LogoComponent } from './logo/logo.component';
import { NgxEditorModule } from 'ngx-editor';
import { EditQuestionSetAlertThresholdComponent } from './questionnaire/questionnaire-builder/edit-question-set-alert-threshold/edit-question-set-alert-threshold.component';
import { EmptyStateComponent } from './empty-state/empty-state.component';
import { PageHeaderComponent } from './layout/page-header/page-header.component';
import { PageShellComponent } from './layout/page-shell/page-shell.component';
import { PageToolbarComponent } from './layout/page-toolbar/page-toolbar.component';
import { AuthShellComponent } from './layout/auth-shell/auth-shell.component';
import { DeactivateAccountDialogComponent } from '../pages/admin/profile/account-details/deactivate-account-dialog/deactivate-account-dialog.component';

@NgModule({
  declarations: [
    NavbarComponent,
    QuestionComponent,
    LongLoadingComponent,
    ShortLoadingComponent,
    ToastComponent,
    EditQuestionComponent,
    HomeNavbarComponent,
    QuestionnaireCardComponent,
    QuestionnaireResponseAnswersComponent,
    ChartComponent,
    FreetextSummaryComponent,
    InviteLinkDetailsComponent,
    AccountDetailsComponent,
    BillingDetailsComponent,
    TransactionHistoryComponent,
    CreateInviteLinkComponent,
    CreateUserComponent,
    AccountSelectComponent,
    SwitchModalComponent,
    PrivacyPolicyComponent,
    TermsAndConditionsComponent,
    BetaLabelComponent,
    EditBranchConditionComponent,
    PaginatorComponent,
    RespondentQuestionnairesComponent,
    RespondentAssociatedQuestionnairesComponent,
    RespondentScheduledQuestionnairesComponent,
    RespondentDetailsFormComponent,
    RespondentAlreadyExistsModalComponent,
    NewScheduledQuestionnaireModalComponent,
    LogoComponent,
    EditQuestionSetAlertThresholdComponent,
    EmptyStateComponent,
    PageHeaderComponent,
    PageShellComponent,
    PageToolbarComponent,
    AuthShellComponent,
    DeactivateAccountDialogComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatTabsModule,
    CdkDropList,
    CdkDrag,
    CdkDragHandle,
    PipesModule,
    MatRippleModule,
    MatDialogModule,
    ReactiveFormsModule,
    ClipboardModule,
    NgOptimizedImage,
    MatTooltipModule,
    MatSelectModule,
    RouterLink,
    NgxEditorModule,
    RouterLinkActive,
  ],
  exports: [
    NavbarComponent,
    QuestionComponent,
    LongLoadingComponent,
    ShortLoadingComponent,
    ToastComponent,
    HomeNavbarComponent,
    QuestionnaireCardComponent,
    AccountSelectComponent,
    PrivacyPolicyComponent,
    TermsAndConditionsComponent,
    BetaLabelComponent,
    RespondentDetailsFormComponent,
    LogoComponent,
    AccountDetailsComponent,
    BillingDetailsComponent,
    TransactionHistoryComponent,
    PaginatorComponent,
    RespondentQuestionnairesComponent,
    RespondentAssociatedQuestionnairesComponent,
    RespondentScheduledQuestionnairesComponent,
    EditQuestionComponent,
    ChartComponent,
    FreetextSummaryComponent,
    EditQuestionSetAlertThresholdComponent,
    EmptyStateComponent,
    PageHeaderComponent,
    PageShellComponent,
    PageToolbarComponent,
    AuthShellComponent,
  ],
  providers: [DatePipe],
})
export class ComponentsModule {}
